import React from 'react'

import { AUTH_MODAL_SPLASH_VIDEO_URL } from '../../constants/config'
import { ModalBackdropScrim, ModalBackdropVideo } from './auth-modal.styled'

export default function AuthModalBackdrop () {
  return (
    <>
      <ModalBackdropVideo
        src={AUTH_MODAL_SPLASH_VIDEO_URL}
        autoPlay
        muted
        loop
        playsInline
        aria-hidden
      />
      <ModalBackdropScrim aria-hidden />
    </>
  )
}
